<div class="wrapper">
  @if (data?.laborDetails) {
    <app-cle-edit-labor-form
      [data]="data?.laborDetails"
    />
  } @else {
    <app-cle-add-labor-form />
  }
  <app-actions-section
    [hideAddMenu]="true"
    [hideLocationOption]="true"
    class="actions-section w-[455px]"
  />
</div>
